// ===== CONFIGURACIÓN INICIAL =====
const STORAGE_KEY = '_sdr_x1f';

// ELIMINADO: KEY_ZCB y llamadas a zipcodebase.com
// Ahora se usa ZipLookup (zip-lookup.js) con datos locales

// Las tiendas son Shopify Pages identificadas por tener custom.get_directions,
// no productos de una coleccion. Debe coincidir con snippets/stores-preloader.liquid:
// ambos llenan la misma clave de sessionStorage con el mismo shape.
const FALLBACK_CONFIG = {
  token: 'cd854423624529a6725bbf29edfc2088',
  domain: 'c74222-e2.myshopify.com',
  apiVersion: '2026-07'
};

// Tiendas aliadas (metaobject partner_store): se leen de la Storefront API y se
// suman a ALLSTORES con isPartner: true. Van en su propia clave de
// sessionStorage, NUNCA en STORAGE_KEY: la próxima visita las cargaría como
// propias y el merge las duplicaría. Debe coincidir con _KPD en
// snippets/stores-preloader.liquid. Docs: docs/partner-stores.md
const PARTNER_STORAGE_KEY = '_sdr_x1f_pd';
// Propias en azul, no en el rojo por defecto de Google, que se confunde con
// sus propios pines. El hover se pinta con colores fijos desde JS
// (setPinHover): en las propias usa #007f92, el mismo azul del botón
// "Get a Quote" y del botón de llamada de su tarjeta (find-store.css).
const OWN_PIN = { background: '#2ea6b8', borderColor: '#2e7e86', glyphColor: '#ffffff' };
const OWN_PIN_HOVER = { background: '#007f92', borderColor: '#005f6d' };
const PARTNER_PIN = { background: '#da257f', borderColor: '#a81c61', glyphColor: '#ffffff' };
const PARTNER_PIN_HOVER = { background: '#ff3fa3', borderColor: '#da257f' };
const PARTNER_UTM = { utm_source: 'ifixandrepair', utm_medium: 'referral', utm_campaign: 'store_locator' };
// Logo de marca a la derecha del nombre: en las aliadas sustituye al badge
// "Partner Store", así que su alt conserva ese texto para lectores de pantalla.
// width/height = tamaño final (ifix 74×54 → 30 px de alto, the_fix 102×35 → 20).
const CARD_LOGOS = {
  own: { src: 'https://cdn.shopify.com/s/files/1/0574/2162/7526/files/ifix-card.png?v=1789160198', alt: 'iFixandRepair store', width: 41, height: 30 },
  partner: { src: 'https://cdn.shopify.com/s/files/1/0574/2162/7526/files/the_fix-card.png?v=1789160198', alt: 'The Fix, partner store', width: 58, height: 20 }
};
const PARTNER_STRINGS = {
  cta: 'Get a Quote',
  opensNewTab: '(opens in new tab)',
  visitPartner: 'Go to {name} page'
};

let ALLSTORES = [];
let map;
const center = { lat: 40.260, lng: -97.000 };

// Section settings and translated strings come from
// <script type="application/json" id="find-store-config"> at the end of the
// section, which does not exist yet when this file runs: read on DOMContentLoaded.
const DEFAULT_CONFIG = {
  defaultRadius: 25,
  radii: [10, 25, 50, 100],
  strings: {
    resultsOne: '1 store within {radius} miles of {place}.',
    resultsOther: '{count} stores within {radius} miles of {place}.',
    stateResultsOne: '1 store in {state}.',
    stateResultsOther: '{count} stores in {state}.',
    browseMany: 'Showing the {shown} closest',
    browseOne: '1 store in this map area.',
    browseOther: '{count} stores in this map area.',
    browseNone: 'No stores in this map area. Zoom out or search by ZIP.',
    noResults: 'No stores within {radius} miles of {place}.',
    closest: 'The closest store is {distance} miles away.',
    radiusOption: 'Within {radius} miles ({count})',
    radiusOptionPlain: 'Within {radius} miles',
    invalidZip: 'Please enter a valid ZIP code',
    zipFirst: 'Please enter a valid ZIP code first',
    cleared: 'Filters cleared. Showing all stores on the map.',
    clusterTitle: '{count} stores. Zoom in to see them',
    yourLocation: 'your location ({place})',
    locating: 'Locating…',
    locateDenied: 'Location access is blocked. Allow it in your browser settings or enter a ZIP code.',
    locateTimeout: 'Finding your location took too long. Try again or enter a ZIP code.',
    locateUnavailable: 'Your location is not available right now. Try again or enter a ZIP code.',
    locateOutside: 'You seem to be outside the area we cover (the US and Puerto Rico). Enter a ZIP code to search.'
  }
};
let CONFIG = DEFAULT_CONFIG;

// "The last action wins" (plans/find-a-store-v2.md): one state object. Every
// control writes it and calls applyState(), which recomputes results and
// redraws list, map, dropdowns and the live region.
const view = {
  mode: 'browse', // browse | zip | location | state | city
  center: null,   // { lat, lng } in zip, location and city modes
  place: null,    // ZipLookup result behind the center (zip/location): context for the dropdowns
  radius: DEFAULT_CONFIG.defaultRadius,
  stateCode: '',
  cityKey: ''
};

// Current results, sorted by distance. Empty while browsing (no search yet).
const nearestStores = [];
// null = browse mode (every store on the map); array = results of a search.
let currentResults = null;

// One marker per store, created once and keyed by store.id, never by list
// position: the same marker is reused by every search and by browse mode.
const markerById = new Map(); // id -> { marker, pin, store }
const storeByMarker = new WeakMap();
let markersReady = false;
let shownMarkers = []; // markers currently on the map
let AdvancedMarker = null;
let highlightedId = null;

// initMap (Maps API callback) and the store data load race each other.
let resolveMapReady;
const mapReady = new Promise(resolve => { resolveMapReady = resolve; });

let submitZip = null;

// ===== CARGA DE DATOS =====

function loadStoresFromCache() {
  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Array.isArray(parsed) && parsed.length > 0) {
        ALLSTORES = parsed;
        console.info(`[find-store] 📦 ${ALLSTORES.length} tiendas desde caché`);
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error reading cache:', e);
  }
  return false;
}

async function fetchStoresFallback() {
  const stores = [];
  let hasNext = true;
  let cursor = null;

  const query = `
    query getStorePages($cursor: String) {
      pages(first: 100, after: $cursor) {
        pageInfo { hasNextPage }
        edges {
          cursor
          node {
            id
            title
            handle
            locationURL: metafield(namespace: "custom", key: "get_directions") { value }
            storeAddress: metafield(namespace: "custom", key: "store_address") { value }
            zipCode: metafield(namespace: "custom", key: "zip_code") { value }
            storeEmail: metafield(namespace: "custom", key: "store_email") { value }
            storePhone: metafield(namespace: "custom", key: "store_phone_number") { value }
            cityState: metafield(namespace: "custom", key: "city_state") { value }
          }
        }
      }
    }
  `;

  try {
    while (hasNext) {
      const response = await fetch(`https://${FALLBACK_CONFIG.domain}/api/${FALLBACK_CONFIG.apiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': FALLBACK_CONFIG.token,
        },
        body: JSON.stringify({
          query,
          variables: { cursor }
        }),
      });

      const result = await response.json();

      if (result.errors) {
        console.error('❌ GraphQL error:', result.errors);
        break;
      }

      const edges = result.data?.pages?.edges || [];

      edges.forEach(edge => {
        const processed = processStoreData(edge.node);
        if (processed) stores.push(processed);
      });

      hasNext = result.data?.pages?.pageInfo?.hasNextPage || false;
      cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
    }

    if (stores.length > 0) {
      ALLSTORES = stores;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stores));
      console.info(`[find-store] 🔄 ${ALLSTORES.length} tiendas desde la API (sin caché)`);
    }

  } catch (error) {
    console.error('❌ Fallback fetch failed:', error);
    throw error;
  }
}

// Recibe una Page de la Storefront API y devuelve el shape canonico de tienda,
// o null si no es una landing de tienda (sin get_directions) o sus coordenadas
// no son extraibles.
function processStoreData(page) {
  try {
    if (!page.locationURL?.value) return null;
    const coords = extractCoordsFromUrl(page.locationURL.value);
    if (!coords) return null;

    return {
      lat: coords.lat,
      lng: coords.lng,
      title: page.title || '',
      handle: page.handle || '',
      address: page.storeAddress?.value || '',
      zipCode: page.zipCode?.value || '',
      phone: page.storePhone?.value || '',
      email: page.storeEmail?.value || '',
      gmapUrl: page.locationURL.value,
      cityState: page.cityState?.value || ''
    };
  } catch (e) {
    return null;
  }
}

async function initStoresData() {
  if (loadStoresFromCache()) return true;
  await fetchStoresFallback();
  return ALLSTORES.length > 0;
}

// Aliadas: caché de sesión (la llena el preloader) o, en la primera visita,
// fetch propio, igual que las propias. Nunca falla hacia afuera: cualquier
// error devuelve [] y el localizador de las propias sigue igual.
async function loadPartnerStores() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(PARTNER_STORAGE_KEY) || 'null');
    if (Array.isArray(cached)) {
      console.info(`[find-store] 🤝 ${cached.length} aliadas desde caché`);
      return cached;
    }
  } catch (e) {
    console.warn('⚠️ Error reading partner cache:', e);
  }

  try {
    const partners = await fetchPartnerStores();
    sessionStorage.setItem(PARTNER_STORAGE_KEY, JSON.stringify(partners));
    console.info(`[find-store] 🤝 ${partners.length} aliadas desde la API (sin caché)`);
    return partners;
  } catch (e) {
    console.warn('[find-store] ⚠️ No se pudieron cargar las aliadas: se muestran solo las propias', e);
    return [];
  }
}

async function fetchPartnerStores() {
  const partners = [];
  let hasNext = true;
  let cursor = null;

  const query = `
    query getPartners($cursor: String) {
      metaobjects(type: "partner_store", first: 250, after: $cursor) {
        pageInfo { hasNextPage endCursor }
        nodes {
          handle
          name:       field(key: "store_name")         { value }
          address:    field(key: "store_address")      { value }
          phone:      field(key: "store_phone_number") { value }
          website:    field(key: "website")            { value }
          directions: field(key: "get_directions")     { value }
          active:     field(key: "active")             { value }
          code:       field(key: "store_code")         { value }
        }
      }
    }
  `;

  while (hasNext) {
    const response = await fetch(`https://${FALLBACK_CONFIG.domain}/api/${FALLBACK_CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': FALLBACK_CONFIG.token,
      },
      body: JSON.stringify({ query, variables: { cursor } }),
    });

    const result = await response.json();
    // Una página a medias no se cachea: se lanza y la sesión reintenta.
    if (result.errors) throw new Error(JSON.stringify(result.errors));

    const page = result.data?.metaobjects;
    (page?.nodes || []).forEach(node => {
      const processed = processPartnerData(node);
      if (processed) partners.push(processed);
    });

    hasNext = page?.pageInfo?.hasNextPage || false;
    cursor = page?.pageInfo?.endCursor || null;
  }

  return partners;
}

// Mismas reglas que _partnerRecord() en snippets/stores-preloader.liquid (fuera
// las inactivas y las que no tienen coordenadas) y mismo shape: si cambian
// aquí, cambiarlas allí.
function processPartnerData(node) {
  if (node.active?.value === 'false') return null;
  const coords = extractCoordsFromUrl(node.directions?.value);
  if (!coords) return null;

  return {
    lat: coords.lat,
    lng: coords.lng,
    title: node.name?.value || '',
    handle: node.handle || '',
    address: node.address?.value || '',
    phone: node.phone?.value || '',
    gmapUrl: node.directions.value,
    website: node.website?.value || '',
    storeCode: node.code?.value || '',
    isPartner: true
  };
}

// ===== UTILIDADES =====

function extractCoordsFromUrl(url) {
  if (!url || typeof url !== 'string') return null;

  // !3d/!4d es la coordenada de la ficha del negocio: se prueba primero.
  // @lat,lng es el centro de la cámara del mapa, no el negocio — coincide
  // cuando la URL sale de abrir la ficha, pero si sale de una búsqueda
  // apunta al centro del área de resultados, y el desvío crece con el zoom.
  const placeMatch = url.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
  if (placeMatch && placeMatch.length >= 3) {
    const lat = parseFloat(placeMatch[1]);
    const lng = parseFloat(placeMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  const viewportMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (viewportMatch && viewportMatch.length >= 3) {
    const lat = parseFloat(viewportMatch[1]);
    const lng = parseFloat(viewportMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  return null;
}

function getDistanceMiles(lat1, lng1, lat2, lng2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// ===== NORMALIZATION =====
// Adds id, stateCode, city and cityKey to every store, once, after the merge.
// City/state are not clean data (see "Measured data" in
// plans/find-a-store-v2.md), so each one is taken from the first source that
// yields it; stores that needed a fallback are reported to the console.

const STATE_CODES = {
  alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA',
  colorado: 'CO', connecticut: 'CT', delaware: 'DE', 'district of columbia': 'DC',
  florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID', illinois: 'IL',
  indiana: 'IN', iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA',
  maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN',
  mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV',
  'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY',
  'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK',
  oregon: 'OR', pennsylvania: 'PA', 'puerto rico': 'PR', 'rhode island': 'RI',
  'south carolina': 'SC', 'south dakota': 'SD', tennessee: 'TN', texas: 'TX',
  utah: 'UT', vermont: 'VT', virginia: 'VA', washington: 'WA',
  'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY'
};
const VALID_STATE_CODES = new Set(Object.values(STATE_CODES));
// ", City, ST 12345" anywhere in a street address.
const ADDRESS_CITY_STATE = /,\s*([^,]+?),\s*([A-Z]{2})\s+(\d{5})/;

// Stores whose city or state did not come from their primary source, plus
// data problems found on the way. Read by the console report only.
const normalizationReport = { fallbacks: [], issues: [] };

function stateCodeFrom(value) {
  const v = String(value ?? '').trim();
  if (v.length === 2 && VALID_STATE_CODES.has(v.toUpperCase())) return v.toUpperCase();
  return STATE_CODES[v.toLowerCase()] || '';
}

// Some Pages store "2141" for "02141" (single_line_text_field).
function normalizeZip(zip) {
  const digits = String(zip ?? '').trim().match(/^\d{3,5}/);
  return digits ? digits[0].padStart(5, '0') : '';
}

function zipEntry(zip) {
  const key = normalizeZip(zip);
  return key ? window.ZIP_DB?.[key] || null : null;
}

// Nearest ZIP centroid to a coordinate: linear scan over ZIP_DB (local, no
// network). Equirectangular distance is enough to rank; the winner gets a
// real Haversine distance.
let zipKeys = null;
function nearestZip(lat, lng) {
  const db = window.ZIP_DB;
  if (!db) return null;
  zipKeys = zipKeys || Object.keys(db);
  const cosLat = Math.cos(lat * Math.PI / 180);
  let best = null;
  let bestScore = Infinity;
  for (const zip of zipKeys) {
    const entry = db[zip];
    const dy = entry.lat - lat;
    const dx = (entry.lng - lng) * cosLat;
    const score = dx * dx + dy * dy;
    if (score < bestScore) { bestScore = score; best = zip; }
  }
  if (!best) return null;
  const entry = db[best];
  return { zip: best, entry, distance: getDistanceMiles(lat, lng, entry.lat, entry.lng) };
}

// "Hagerstown, Maryland" or "Cambridge, MA".
function parseCityState(value) {
  const m = String(value ?? '').match(/^\s*([^,]+?)\s*,\s*([^,]+?)\s*$/);
  return m ? { city: m[1], stateCode: stateCodeFrom(m[2]) } : null;
}

// A "city" with a digit or "#" is a street/suite fragment
// ("1 Mills Cir, #523 Entrance 5 Ontario, CA"): rejected, next source wins.
function parseAddress(value) {
  const m = String(value ?? '').match(ADDRESS_CITY_STATE);
  if (!m || !VALID_STATE_CODES.has(m[2]) || /[\d#]/.test(m[1])) return null;
  return { city: m[1].trim(), stateCode: m[2], zip: m[3] };
}

// Partner store_code: "Walmart 2071 Anchorage AK", "Ontario Mills / Ontario CA".
// Keep the part after the last "/" or " - ", drop everything up to the last
// token with a digit (the store number); the last token left is the state.
function parseStoreCode(value) {
  const tail = String(value ?? '').split(/\/|\s[-–]\s/).pop().replace(/,/g, ' ').trim();
  const tokens = tail.split(/\s+/).filter(Boolean);
  const lastNumber = tokens.findLastIndex(token => /\d/.test(token));
  const rest = tokens.slice(lastNumber + 1);
  if (rest.length < 2) return null;
  const stateCode = stateCodeFrom(rest[rest.length - 1]);
  return stateCode ? { city: rest.slice(0, -1).join(' '), stateCode } : null;
}

// "TITUSVILLE" → "Titusville"; mixed-case names are left as typed.
function tidyCity(city) {
  const c = String(city ?? '').trim().replace(/\s+/g, ' ');
  if (c !== c.toUpperCase()) return c;
  return c.toLowerCase().replace(/(^|[\s'-])\p{L}/gu, ch => ch.toUpperCase());
}

// Grouping key, so "St. Louis", "St Louis" and "Saint Louis" are one city,
// and ZIP_DB's "Bayamon" matches the store's "Bayamón".
function cityKeyFor(stateCode, city) {
  const name = city.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\./g, '').replace(/^saint\s/, 'st ').replace(/^mount\s/, 'mt ');
  return `${stateCode}|${name}`.toLowerCase();
}

function pickField(candidates, field) {
  const hit = candidates.find(c => c && c[field]);
  return hit ? { value: hit[field], source: hit.source } : { value: '', source: '' };
}

function normalizeStore(store, usedIds) {
  const kind = store.isPartner ? 'partner' : 'own';
  let id = `${kind}:${store.handle || store.title}`;
  while (usedIds.has(id)) id += '+';
  usedIds.add(id);

  const fromAddress = parseAddress(store.address);
  let stateCandidates;
  let cityCandidates;

  if (store.isPartner) {
    const fromCode = parseStoreCode(store.storeCode);
    if (fromAddress) fromAddress.source = 'address';
    if (fromCode) fromCode.source = 'store_code';
    stateCandidates = [fromAddress, fromCode];
    cityCandidates = [fromAddress, fromCode];
  } else {
    const entry = zipEntry(store.zipCode);
    const fromZip = entry && { city: entry.city, stateCode: entry.sc, source: 'zip_code' };
    const fromCityState = parseCityState(store.cityState);
    if (fromAddress) fromAddress.source = 'address';
    if (fromCityState) fromCityState.source = 'city_state';
    stateCandidates = [fromZip, fromAddress, fromCityState];
    cityCandidates = [fromCityState, fromAddress, fromZip];

    const zipRaw = String(store.zipCode ?? '').trim();
    if (zipRaw && zipRaw !== normalizeZip(zipRaw)) {
      normalizationReport.issues.push({ id, title: store.title, problem: 'zip_code without leading zero', value: zipRaw, suggested: normalizeZip(zipRaw) });
    }
    if (!fromAddress) {
      normalizationReport.issues.push({ id, title: store.title, problem: 'store_address does not parse as ", City, ST 12345"', value: store.address });
    }
    if (fromZip && fromCityState?.stateCode && fromCityState.stateCode !== fromZip.stateCode) {
      normalizationReport.issues.push({ id, title: store.title, problem: 'city_state state differs from zip_code state', value: store.cityState, suggested: fromZip.stateCode });
    }
  }

  let state = pickField(stateCandidates, 'stateCode');
  let city = pickField(cityCandidates, 'city');
  if (!state.value || !city.value) {
    const near = nearestZip(store.lat, store.lng);
    const fromNearest = near && { city: near.entry.city, stateCode: near.entry.sc, source: `nearest ZIP ${near.zip}` };
    if (!state.value) state = pickField([fromNearest], 'stateCode');
    if (!city.value) city = pickField([fromNearest], 'city');
  }

  const cityPrimary = store.isPartner ? 'address' : 'city_state';
  const statePrimary = store.isPartner ? 'address' : 'zip_code';
  if (city.source !== cityPrimary || state.source !== statePrimary) {
    normalizationReport.fallbacks.push({
      id, title: store.title, city: city.value, citySource: city.source,
      stateCode: state.value, stateSource: state.source,
      address: store.address, extra: store.isPartner ? store.storeCode : store.cityState
    });
  }

  const cityName = tidyCity(city.value);
  return {
    ...store,
    id,
    city: cityName,
    stateCode: state.value,
    cityKey: cityKeyFor(state.value, cityName)
  };
}

function normalizeStores(stores) {
  normalizationReport.fallbacks.length = 0;
  normalizationReport.issues.length = 0;
  const usedIds = new Set();
  const normalized = stores.map(store => normalizeStore(store, usedIds));

  const { fallbacks, issues } = normalizationReport;
  if (fallbacks.length || issues.length) {
    console.groupCollapsed(`[find-store] ⚠️ Normalización: ${fallbacks.length} tienda(s) con ciudad/estado de respaldo · ${issues.length} problema(s) de datos`);
    if (fallbacks.length) console.warn('Ciudad/estado de respaldo:', fallbacks);
    if (issues.length) console.warn('Problemas de datos:', issues);
    console.groupEnd();
  }
  return normalized;
}

// ===== STATE → RESULTS =====

function readConfig() {
  try {
    const el = document.getElementById('find-store-config');
    if (!el) return DEFAULT_CONFIG;
    const parsed = JSON.parse(el.textContent);
    const radii = Array.isArray(parsed.radii) && parsed.radii.length ? parsed.radii : DEFAULT_CONFIG.radii;
    return {
      radii,
      defaultRadius: radii.includes(parsed.defaultRadius) ? parsed.defaultRadius : DEFAULT_CONFIG.defaultRadius,
      strings: { ...DEFAULT_CONFIG.strings, ...parsed.strings }
    };
  } catch (e) {
    console.warn('[find-store] ⚠️ find-store-config ilegible, se usan los textos por defecto', e);
    return DEFAULT_CONFIG;
  }
}

// Translated string with {token} placeholders. A key Shopify could not
// resolve ("translation missing: …") falls back to the English default.
function t(key, vars = {}) {
  let template = CONFIG.strings[key];
  if (!template || template.startsWith('translation missing')) template = DEFAULT_CONFIG.strings[key] || '';
  return template.replace(/\{(\w+)\}/g, (match, name) => (name in vars ? vars[name] : match));
}

// Every store with its distance to a point, closest first.
function rankByDistance(point) {
  return ALLSTORES
    .map(store => ({ ...store, distance: getDistanceMiles(point.lat, point.lng, store.lat, store.lng) }))
    .sort((a, b) => a.distance - b.distance);
}

function placeLabel(place) {
  return place ? `${place.city}, ${place.stateCode} ${place.zipCode}`.trim() : '';
}

function applyState() {
  hideLocateError();
  pinnedId = null;
  const hasCenter = Boolean(view.center) && ['zip', 'location', 'city'].includes(view.mode);
  const ranked = hasCenter ? rankByDistance(view.center) : null;
  let results = ranked ? ranked.filter(store => store.distance <= view.radius) : null;
  // State mode has no center (radius disabled): every store in the state,
  // by city and then name.
  if (view.mode === 'state') {
    results = ALLSTORES
      .filter(store => store.stateCode === view.stateCode)
      .sort((a, b) => a.city.localeCompare(b.city) || a.title.localeCompare(b.title));
  }

  nearestStores.length = 0;
  if (results) nearestStores.push(...results);
  currentResults = results;

  renderControls(ranked);
  renderResults(results, ranked);
  renderMap();
}

// Visible summary, list and live region.
function renderResults(results, ranked) {
  const list = document.getElementById('found-stores');
  const summary = document.getElementById('store-results-summary');
  const browsing = results === null;

  list?.classList.toggle('hide', browsing || results.length === 0);

  if (browsing) {
    renderBrowseList();
    return;
  }
  const showAll = document.getElementById('show-all-in-view');
  if (showAll) showAll.hidden = true;

  const place = view.mode === 'location' ? t('yourLocation', { place: placeLabel(view.place) }) : placeLabel(view.place);
  const vars = { count: results.length, radius: view.radius, place };
  let message = t(results.length === 1 ? 'resultsOne' : 'resultsOther', vars);
  if (view.mode === 'state') {
    message = t(results.length === 1 ? 'stateResultsOne' : 'stateResultsOther', { count: results.length, state: STATE_NAMES[view.stateCode] || view.stateCode });
  } else if (results.length === 0) {
    // Zero results are normal: say how far the closest store is, never widen.
    message = t('noResults', vars);
    if (ranked?.length) message += ' ' + t('closest', { distance: Math.round(ranked[0].distance) });
  }

  if (summary) {
    summary.textContent = message;
    summary.classList.toggle('store-results-summary--empty', results.length === 0);
    summary.hidden = false;
  }
  if (list) list.scrollTop = 0;
  showStoresHTML(results);
  announceResults(message);
}

// ===== BROWSE: THE LIST FOLLOWS THE MAP =====
// Without a search the list shows the stores inside the map viewport,
// recomputed on every map 'idle'. Above the cap, only the closest to the center.

const LIST_MAX_IN_VIEW = 50;
// A pin clicked whose card is not in the capped list: the list shows only it.
let pinnedId = null;

function storesInView() {
  const bounds = map?.getBounds();
  return bounds ? ALLSTORES.filter(store => bounds.contains({ lat: store.lat, lng: store.lng })) : null;
}

function renderBrowseList() {
  const list = document.getElementById('found-stores');
  const summary = document.getElementById('store-results-summary');
  const showAll = document.getElementById('show-all-in-view');
  const inView = storesInView();

  let cards = null;
  let message = '';
  if (inView === null) {
    // Map not ready yet: empty panel.
  } else if (pinnedId && markerById.has(pinnedId)) {
    cards = [markerById.get(pinnedId).store];
  } else if (inView.length === 0) {
    message = t('browseNone');
  } else {
    // Sorted by distance to the map center. The distance is only a sort key:
    // it is not stored on the card data (GA reads store.distance).
    const c = map.getCenter();
    cards = inView
      .map(store => ({ store, d: getDistanceMiles(c.lat(), c.lng(), store.lat, store.lng) }))
      .sort((a, b) => a.d - b.d)
      .slice(0, LIST_MAX_IN_VIEW)
      .map(entry => entry.store);
    message = inView.length > LIST_MAX_IN_VIEW
      ? t('browseMany', { shown: cards.length })
      : t(cards.length === 1 ? 'browseOne' : 'browseOther', { count: cards.length });
  }

  list?.classList.toggle('hide', !cards);
  if (showAll) showAll.hidden = !pinnedId;
  if (summary) {
    summary.textContent = message;
    summary.classList.remove('store-results-summary--empty');
    summary.hidden = !message;
  }
  showStoresHTML(cards || []);
}

function onMapIdle() {
  if (view.mode !== 'browse') return;
  // Once the viewport holds few enough stores, the pinned one is in the list
  // anyway: back to the normal list.
  if (pinnedId) {
    const inView = storesInView();
    if (inView && inView.length > 0 && inView.length <= LIST_MAX_IN_VIEW) pinnedId = null;
  }
  renderBrowseList();
}

// Pin activated (click, tap or Enter on a focused pin) → its card in the list.
function showStoreFromPin(id) {
  if (view.mode === 'browse' && !cardFor(id)) {
    pinnedId = id;
    renderBrowseList();
  }
  const card = cardFor(id);
  if (!card) return;
  flashHighlight(id, 2000);
  scrollCardIntoList(id);
  card.focus({ preventScroll: true });

  // Stacked layout (mobile): the list sits above the map, so bring the card
  // on screen. Side by side (desktop) the page never moves.
  const list = document.getElementById('found-stores');
  const mapEl = document.getElementById('map');
  if (!list || !mapEl || list.getBoundingClientRect().bottom > mapEl.getBoundingClientRect().top) return;
  const rect = card.getBoundingClientRect();
  if (rect.top < 0 || rect.bottom > window.innerHeight) {
    card.scrollIntoView({ block: 'nearest', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }
}

function showAllInView() {
  pinnedId = null;
  renderBrowseList();
  document.getElementById('store-results-summary')?.focus();
}

// ===== CONTROLS =====

const STATE_NAMES = Object.fromEntries(Object.entries(STATE_CODES).map(([name, code]) => [
  code,
  name.replace(/\b\w/g, ch => ch.toUpperCase()).replace(/ Of /g, ' of ')
]));

// Only states and cities that have stores: the dropdowns never offer an
// empty choice. Built once, after normalization.
let stateOptions = [];          // [{ code, name }] sorted by name
const citiesByState = new Map(); // code -> [{ key, name }] sorted by name

function buildFilterOptions() {
  citiesByState.clear();
  const seen = new Set();
  ALLSTORES.forEach(store => {
    if (!store.stateCode || !store.cityKey || seen.has(store.cityKey)) return;
    seen.add(store.cityKey);
    if (!citiesByState.has(store.stateCode)) citiesByState.set(store.stateCode, []);
    citiesByState.get(store.stateCode).push({ key: store.cityKey, name: store.city });
  });
  citiesByState.forEach(cities => cities.sort((a, b) => a.name.localeCompare(b.name)));
  stateOptions = [...citiesByState.keys()]
    .map(code => ({ code, name: STATE_NAMES[code] || code }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

// City center = mean of the ZIP_DB centroids with that city name and state;
// fallback, the mean of that city's stores. One pass over ZIP_DB, only for
// cities that have stores.
const cityCenters = new Map(); // cityKey -> { lat, lng }

function buildCityCenters() {
  cityCenters.clear();
  const sums = new Map();
  const add = (key, lat, lng) => {
    const sum = sums.get(key) || { lat: 0, lng: 0, n: 0 };
    sum.lat += lat; sum.lng += lng; sum.n += 1;
    sums.set(key, sum);
  };
  const wanted = new Set();
  citiesByState.forEach(cities => cities.forEach(c => wanted.add(c.key)));

  const db = window.ZIP_DB || {};
  Object.keys(db).forEach(zip => {
    const entry = db[zip];
    const key = cityKeyFor(entry.sc, tidyCity(entry.city));
    if (wanted.has(key)) add(key, entry.lat, entry.lng);
  });
  sums.forEach((sum, key) => cityCenters.set(key, { lat: sum.lat / sum.n, lng: sum.lng / sum.n }));

  const fallback = new Map();
  ALLSTORES.forEach(store => {
    if (cityCenters.has(store.cityKey)) return;
    const sum = fallback.get(store.cityKey) || { lat: 0, lng: 0, n: 0 };
    sum.lat += store.lat; sum.lng += store.lng; sum.n += 1;
    fallback.set(store.cityKey, sum);
  });
  fallback.forEach((sum, key) => cityCenters.set(key, { lat: sum.lat / sum.n, lng: sum.lng / sum.n }));
}

function cityByKey(key) {
  for (const [stateCode, cities] of citiesByState) {
    const city = cities.find(c => c.key === key);
    if (city) return { ...city, stateCode };
  }
  return null;
}

// Replaces every option but the first ("All states" / "All cities", rendered
// by Liquid from the section settings).
function setOptions(select, options) {
  while (select.options.length > 1) select.remove(1);
  options.forEach(({ value, label, disabled }) => {
    const option = new Option(label, value);
    if (disabled) {
      option.disabled = true;
      option.dataset.temp = '';
    }
    select.add(option);
  });
}

function cityOptionsFor(stateCode) {
  if (stateCode) return (citiesByState.get(stateCode) || []).map(c => ({ value: c.key, label: c.name }));
  return stateOptions
    .flatMap(s => (citiesByState.get(s.code) || []).map(c => ({ value: c.key, label: `${c.name}, ${s.code}` })))
    .sort((a, b) => a.label.localeCompare(b.label));
}

function renderControls(ranked) {
  const stateSelect = document.getElementById('filter-state');
  const citySelect = document.getElementById('filter-city');
  const radiusSelect = document.getElementById('filter-radius');
  const clearButton = document.getElementById('clear-filters');

  // In zip/location mode State and City show the place as context only:
  // they do not filter (a NJ ZIP still lists Manhattan stores).
  const context = view.place && ['zip', 'location'].includes(view.mode);
  const stateCode = context ? view.place.stateCode : view.stateCode;
  let cityKey = view.cityKey;

  if (stateSelect) {
    const options = stateOptions.map(s => ({ value: s.code, label: s.name }));
    if (stateCode && !citiesByState.has(stateCode)) {
      options.push({ value: stateCode, label: STATE_NAMES[stateCode] || stateCode, disabled: true });
    }
    setOptions(stateSelect, options);
    stateSelect.value = stateCode || '';
  }

  if (citySelect) {
    const options = cityOptionsFor(stateCode);
    if (context) {
      cityKey = cityKeyFor(view.place.stateCode, tidyCity(view.place.city));
      // The ZIP's city has no stores: show its name anyway, as a disabled option.
      if (!options.some(o => o.value === cityKey)) options.unshift({ value: cityKey, label: tidyCity(view.place.city), disabled: true });
    }
    setOptions(citySelect, options);
    citySelect.value = cityKey || '';
  }

  if (radiusSelect) {
    // Each option shows how many stores it would return for the current center.
    [...radiusSelect.options].forEach(option => {
      const radius = Number(option.value);
      option.textContent = ranked
        ? t('radiusOption', { radius, count: ranked.filter(store => store.distance <= radius).length })
        : t('radiusOptionPlain', { radius });
    });
    radiusSelect.value = String(view.radius);
    radiusSelect.disabled = view.mode === 'state';
  }

  if (clearButton) clearButton.hidden = view.mode === 'browse';
}

// ===== MARCADORES DEL MAPA =====

// Cluster look: own, partner or mixed. Colors and size live in find-store.css
// (.store-cluster); the size step is a CSS variable so the design can change
// without touching JS.
const clusterRenderer = {
  render({ count, position, markers: clustered }) {
    const partners = clustered.filter(m => storeByMarker.get(m)?.isPartner).length;
    const kind = partners === 0 ? 'own' : partners === count ? 'partner' : 'mixed';
    const el = document.createElement('div');
    el.className = `store-cluster store-cluster--${kind}`;
    el.textContent = count;
    el.style.setProperty('--cluster-step', String(Math.min(3, Math.floor(Math.log10(count)))));
    return new AdvancedMarker({
      position,
      content: el,
      title: t('clusterTitle', { count }),
      gmpClickable: true,
      zIndex: 1000 + count
    });
  }
};

// Creates the 690-ish markers once and the clusterer. Needs the map and the
// normalized stores; called when both are ready.
async function buildMarkers() {
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
  AdvancedMarker = AdvancedMarkerElement;

  ALLSTORES.forEach(store => {
    // Propias en naranja, aliadas en rosa. content es el PinElement mismo:
    // pin.element está deprecado en la versión de Maps que carga el tema.
    const pin = new PinElement(store.isPartner ? PARTNER_PIN : OWN_PIN);
    const marker = new AdvancedMarkerElement({
      position: { lat: store.lat, lng: store.lng },
      content: pin,
      title: store.title,
      // Focusable with the keyboard; Enter fires gmp-click like a click.
      gmpClickable: true
    });
    marker.element.classList.add('marker-element');
    if (store.isPartner) marker.element.classList.add('marker-partner');

    // Pin → tarjeta: la tarjeta puede estar bajo el scroll de la lista. El
    // scroll espera un poco (hover intent) para que cruzar el mapa con el
    // ratón por encima de varios pines no haga saltar la lista.
    const id = store.id;
    marker.element.addEventListener('mouseenter', () => {
      highlightOnly(id);
      clearTimeout(listScrollTimer);
      listScrollTimer = setTimeout(() => scrollCardIntoList(id), LIST_SCROLL_DELAY);
    });
    marker.element.addEventListener('mouseleave', () => {
      clearTimeout(listScrollTimer);
      removeHighlightStoreAndMarker(id);
    });
    // Click, tap and keyboard all arrive as gmp-click. (The old touchstart
    // handler called preventDefault, which would swallow the tap's click.)
    marker.addEventListener('gmp-click', () => showStoreFromPin(id));

    markerById.set(id, { marker, pin, store });
    storeByMarker.set(marker, store);
  });

  markersReady = true;
  map.addListener('idle', onMapIdle);
}

// Puts the current view on the map: every store (browse) or only the results.
function renderMap() {
  if (!markersReady) return;
  const stores = currentResults || ALLSTORES;
  const shown = stores.map(store => markerById.get(store.id)).filter(Boolean);

  shown.forEach(({ marker, store }) => {
    marker.title = store.distance != null ? `${store.title} (${store.distance.toFixed(2)} mi)` : store.title;
  });
  shownMarkers.forEach(marker => { marker.map = null; });
  shownMarkers = shown.map(entry => entry.marker);
  shownMarkers.forEach(marker => { marker.map = map; });

  if (stores.length) {
    fitMapToBounds(stores);
  } else if (view.center) {
    fitMapToRadius(view.center, view.radius);
  }
}

// Zero results: frame the searched circle so the empty radius is visible.
async function fitMapToRadius(point, radiusMiles) {
  if (!map) return;
  const { LatLngBounds } = await google.maps.importLibrary("core");
  const dLat = radiusMiles / 69;
  const dLng = radiusMiles / (69 * Math.cos(point.lat * Math.PI / 180));
  map.fitBounds(new LatLngBounds(
    { lat: point.lat - dLat, lng: point.lng - dLng },
    { lat: point.lat + dLat, lng: point.lng + dLng }
  ));
}

// Zoom maximo al encuadrar resultados. Sin tope, una sola tienda (o dos en el
// mismo centro comercial) lleva fitBounds al zoom 22, a nivel de edificio.
const MAX_FIT_ZOOM = 15;

async function fitMapToBounds(stores = nearestStores) {
  if (!map || stores.length === 0) return;
  // LatLng y LatLngBounds viven en "core", no en "maps".
  const { LatLngBounds, LatLng, event } = await google.maps.importLibrary("core");
  const bounds = new LatLngBounds();
  stores.forEach(location => bounds.extend(new LatLng(location.lat, location.lng)));
  event.addListenerOnce(map, 'idle', () => {
    if (map.getZoom() > MAX_FIT_ZOOM) map.setZoom(MAX_FIT_ZOOM);
  });
  map.fitBounds(bounds);
}

// ===== ZIP SEARCH AND FILTER CONTROLS =====
// ZipLookup.resolveZip() reads us-zipcodes.js locally: instant, no network.

function searchZip(zipCode) {
  const place = ZipLookup.resolveZip(zipCode);
  if (!place) {
    showZipError(t('invalidZip'));
    return false;
  }
  hideZipError();
  Object.assign(view, { mode: 'zip', center: place.location, place, stateCode: '', cityKey: '' });
  const input = document.getElementById('location-search');
  if (input) input.value = place.zipCode;
  if (submitZip) submitZip.disabled = false;
  applyState();
  return true;
}

function clearFilters() {
  Object.assign(view, { mode: 'browse', center: null, place: null, radius: CONFIG.defaultRadius, stateCode: '', cityKey: '' });
  const input = document.getElementById('location-search');
  if (input) input.value = '';
  hideZipError();
  if (submitZip) submitZip.disabled = true;

  // A reload must not bring the deep-linked ZIP back.
  const url = new URL(window.location.href);
  if (url.searchParams.has('zipcode')) {
    url.searchParams.delete('zipcode');
    history.replaceState(history.state, '', url);
  }

  applyState();
  announceResults(t('cleared'));
  // The Clear button just hid itself: keep focus in the form.
  input?.focus();
}

function initControls() {
  submitZip = document.getElementById('location-search-button');
  const form = document.getElementById('store-filters');
  const input = document.getElementById('location-search');
  const radiusSelect = document.getElementById('filter-radius');

  // Disabled until the input holds a known ZIP (the section's button_help
  // text describes this behaviour).
  if (submitZip) submitZip.disabled = true;

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    const zip = input?.value.trim() || '';
    if (!/^\d{5}$/.test(zip)) {
      showZipError(t('zipFirst'));
      return;
    }
    searchZip(zip);
  });

  input?.addEventListener('input', () => {
    hideZipError();
    if (input.value.length > 5) input.value = input.value.slice(0, 5);
    const zip = input.value.trim();
    const valid = /^\d{5}$/.test(zip) && Boolean(ZipLookup.resolveZip(zip));
    if (submitZip) submitZip.disabled = !valid;
    if (/^\d{5}$/.test(zip) && !valid) showZipError(t('invalidZip'));
  });

  radiusSelect?.addEventListener('change', () => {
    view.radius = Number(radiusSelect.value);
    // Changing the radius re-runs the current mode; while browsing there is
    // no center yet, so it is only remembered for the next search.
    if (view.mode !== 'browse') applyState();
  });

  document.getElementById('filter-state')?.addEventListener('change', (e) => selectState(e.target.value));
  document.getElementById('filter-city')?.addEventListener('change', (e) => selectCity(e.target.value));

  document.getElementById('clear-filters')?.addEventListener('click', clearFilters);
  document.getElementById('show-all-in-view')?.addEventListener('click', showAllInView);
  // Programmatic focus target after "Show all stores in view".
  document.getElementById('store-results-summary')?.setAttribute('tabindex', '-1');
}

// ===== CURRENT LOCATION =====
// Browser Geolocation API, requested only on click, never on load. The exact
// coordinate is the center; the nearest ZIP (local scan of ZIP_DB) only fills
// the ZIP input and the State/City context.

// Farther than this from any ZIP centroid = outside the US and Puerto Rico.
const LOCATION_MAX_ZIP_MI = 50;
const GEOLOCATION_OPTIONS = { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 };

function initLocateButton() {
  const button = document.getElementById('use-location');
  if (!button) return;
  // No API (old browser or insecure context): the button stays hidden.
  if (!('geolocation' in navigator)) return;
  button.dataset.label = button.textContent.trim();
  button.hidden = false;
  button.addEventListener('click', locateUser);
}

function setLocating(on) {
  const button = document.getElementById('use-location');
  if (!button) return;
  // Hold the width while the label swaps, so the selects next to it stay put.
  button.style.minWidth = on ? `${button.getBoundingClientRect().width}px` : '';
  button.disabled = on;
  button.setAttribute('aria-busy', String(on));
  // Only the text span: the icon next to it stays.
  const label = button.querySelector('.store-filters__locate-text') || button;
  label.textContent = on ? t('locating') : button.dataset.label;
}

function showLocateError(message) {
  const el = document.getElementById('locate-error');
  if (!el) return;
  hideZipError(); // both messages share one slot under the bar
  el.textContent = message;
  el.hidden = false;
}

function hideLocateError() {
  const el = document.getElementById('locate-error');
  if (!el || el.hidden) return;
  el.hidden = true;
  el.textContent = '';
}

function locateUser() {
  hideLocateError();
  setLocating(true);
  navigator.geolocation.getCurrentPosition(
    (position) => {
      setLocating(false);
      useLocation(position.coords.latitude, position.coords.longitude);
    },
    (error) => {
      setLocating(false);
      const key = error.code === error.PERMISSION_DENIED ? 'locateDenied'
        : error.code === error.TIMEOUT ? 'locateTimeout'
        : 'locateUnavailable';
      showLocateError(t(key));
    },
    GEOLOCATION_OPTIONS
  );
}

function useLocation(lat, lng) {
  const near = nearestZip(lat, lng);
  if (!near || near.distance > LOCATION_MAX_ZIP_MI) {
    showLocateError(t('locateOutside'));
    return;
  }
  const place = ZipLookup.resolveZip(near.zip) || { city: near.entry.city, stateCode: near.entry.sc, zipCode: near.zip };
  hideZipError();
  Object.assign(view, { mode: 'location', center: { lat, lng }, place, stateCode: '', cityKey: '' });
  const input = document.getElementById('location-search');
  if (input) input.value = near.zip;
  if (submitZip) submitZip.disabled = false;
  applyState();
}

// The ZIP stops applying as soon as State or City take over.
function clearZipInput() {
  const input = document.getElementById('location-search');
  if (input) input.value = '';
  hideZipError();
  if (submitZip) submitZip.disabled = true;
}

// State: every store in it, the map fits them, City narrows to its cities,
// radius is disabled (no center). "All states" goes back to browsing.
function selectState(stateCode) {
  clearZipInput();
  if (!stateCode) {
    Object.assign(view, { mode: 'browse', center: null, place: null, stateCode: '', cityKey: '' });
  } else {
    Object.assign(view, { mode: 'state', center: null, place: null, stateCode, cityKey: '' });
  }
  applyState();
}

// City: stores within the radius of the city center, not an exact name
// match (suburbs count). Picking a city under "All states" also sets State.
// "All cities" falls back to the state, or to browsing.
function selectCity(cityKey) {
  clearZipInput();
  const city = cityKey ? cityByKey(cityKey) : null;
  if (!city) {
    selectState(view.stateCode);
    return;
  }
  Object.assign(view, {
    mode: 'city',
    center: cityCenters.get(city.key) || null,
    place: { city: city.name, stateCode: city.stateCode, zipCode: '' },
    stateCode: city.stateCode,
    cityKey: city.key
  });
  applyState();
}

function showZipError(message) {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  hideLocateError(); // both messages share one slot under the bar
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.classList.remove('hidden');
  }
  if (inputElement) inputElement.classList.add('error');
}

function hideZipError() {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  if (errorElement) errorElement.classList.add('hidden');
  if (inputElement) inputElement.classList.remove('error');
}

// ===== RESULTADOS HTML =====

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

// Landing de la aliada con UTM. '' si website está vacío o no es una URL:
// en ese caso la tarjeta sale sin enlaces.
function partnerUrl(store) {
  if (!store.website) return '';
  try {
    const url = new URL(store.website);
    Object.entries(PARTNER_UTM).forEach(([key, value]) => url.searchParams.set(key, value));
    url.searchParams.set('utm_content', store.handle);
    return url.toString();
  } catch (e) {
    return '';
  }
}

// Mismo icono (globo) para ir a la landing, propia o de aliada. El color lo
// pone .store-link-icon en find-store.css (tenue, pero con 3:1).
const LANDING_ICON = '<svg class="store-link-icon" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor" aria-hidden="true" focusable="false"><path d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5ZM480-162q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>';
const CALL_ICON ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="25 28 223 223" width="18" height="18" fill="currentColor" aria-hidden="true" focusable="false"><path d="M208.2,175.4c11.4,4.3,26.4,15.7,32.9,26.1,4.8,7.7,4.3,16.5-.8,24-4.1,6-9.5,10.7-14.6,15.9s-10.3,8.3-17.7,8.6c-21.3,1.1-46.1-10-64.5-21.5-38.5-24-70.8-56.9-94-95.9-11.7-19.7-23-46.4-21.1-68.9.6-7.1,3.9-12.2,8.7-16.9,5.2-5,10-10,15.8-14.1,9-6.2,19.6-5.7,28,1.9s16.3,18.3,21.2,29.3c7.3,16.5-5.2,25.1-15.5,35.5-5.6,5.7,2.8,20.5,8.7,28.5,14.4,19.4,31,36.6,49.6,52,8,6.6,22.7,15.9,29.2,10l12.6-11.4c5.9-5.3,13.9-6.1,21.4-3.2Z"/><path d="M218.1,143.7c1.3-48.1-37.9-87.7-86.2-86.7l-.3-9.5c53.3-1.4,97.6,42.8,96.1,96.4l-9.6-.2Z"/><path d="M192.6,143c.8-33.9-26.9-61.3-60.4-60.5v-9.6c38.9-.9,70.9,31,70,70.2l-9.6-.2Z"/><path d="M166.8,142.3c.1-19.3-15-34.4-34.2-34l-.2-9.6c24.6-.5,44.1,19.2,43.8,43.7h-9.5Z"/></svg>';

// Tarjeta de aliada. Todo valor pasa por escapeHtml (hay un "Lee's Summit").
// El CTA es un <a> SIN la clase openQuoteMap: no abre el modal de iFix.
// rel sin noreferrer, para que The Fix vea que la visita viene de iFix.
// sponsored (no nofollow): es una referencia comercial a otra marca; iFix no
// compite con thefixsolutions.com por esas tiendas (decisión de Rony, 2026-09-11).
function partnerCardHTML(store, index) {
  const s = PARTNER_STRINGS;
  const url = escapeHtml(partnerUrl(store));
  const name = escapeHtml(store.title);
  const phone = escapeHtml(store.phone);
  const opensNewTab = escapeHtml(s.opensNewTab);
  const visit = escapeHtml(s.visitPartner.replace('{name}', store.title));

  const nameHTML = url
    ? `<a href="${url}" target="_blank" rel="noopener sponsored" data-partner-link="name" title="${visit}" aria-label="${visit} ${opensNewTab}">${name} ${LANDING_ICON}</a>`
    : name;
  const ctaHTML = url
    ? `<a href="${url}" target="_blank" rel="noopener sponsored" data-partner-link="cta" class="button medium partner-cta" aria-label="${escapeHtml(s.cta)}: ${name} ${opensNewTab}">${escapeHtml(s.cta)}</a>`
    : '';

  return `
    <article class="store-item store-item--partner" tabindex="-1" data-index="${index}" data-store-id="${escapeHtml(store.id)}">
      <header class="store-name">
        <span class="store-name__title">${nameHTML}</span>
        ${cardLogoHTML(CARD_LOGOS.partner)}
      </header>
      <div class="store-address">${escapeHtml(store.address)}</div>
      <div class="store-address store-phone">
        <a href="tel:${phone}">${phone}</a>
      </div>
      <div class="store-btns">
        <button class="button medium" data-directions="${escapeHtml(store.gmapUrl)}">Directions</button>
        ${ctaHTML}
        <a href="tel:${phone}" class="icon-button call-button" aria-label="Call ${name} at ${phone}" title="Call to this store">${CALL_ICON}</a>
      </div>
    </article>
  `;
}

function cardLogoHTML(logo) {
  return `<img class="store-name__logo" src="${logo.src}" alt="${logo.alt}" width="${logo.width}" height="${logo.height}" loading="lazy" decoding="async">`;
}

function trackPartnerClick(store, linkType) {
  if (typeof gtag !== 'function' || !store) return;
  try {
    gtag('event', 'partner_store_click', {
      store_handle: store.handle,
      store_name: store.title,
      link_type: linkType,
      distance_mi: typeof store.distance === 'number' ? Number(store.distance.toFixed(1)) : undefined
    });
  } catch (e) {
    // Un GA roto nunca debe romper el enlace.
  }
}

// Región viva: los lectores de pantalla oyen cuántas tiendas hay tras cada
// búsqueda (propias y aliadas juntas, como se ven en la lista).
function announceResults(message) {
  let region = document.getElementById('found-stores-status');
  if (!region) {
    region = document.createElement('div');
    region.id = 'found-stores-status';
    region.className = 'sr-only';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    document.body.appendChild(region);
  }
  region.textContent = '';
  setTimeout(() => { region.textContent = message; }, 100);
}

function showStoresHTML(storesArray) {
  const storesContainer = document.getElementById("found-stores");
  if (!storesContainer) return;

  // The summary and the live region are written by renderResults().
  if (!storesArray || storesArray.length === 0) {
    storesContainer.innerHTML = '';
    return;
  }

  storesContainer.innerHTML = storesArray.map((store, index) => store.isPartner ? partnerCardHTML(store, index) : ownCardHTML(store, index)).join('');

  storesContainer.querySelectorAll('.store-item').forEach(storeItem => {
    const id = storeItem.dataset.storeId;
    storeItem.addEventListener('mouseenter', () => highlightOnly(id));
    storeItem.addEventListener('mouseleave', () => removeHighlightStoreAndMarker(id));
    storeItem.addEventListener('touchstart', () => flashHighlight(id, 2000));
    storeItem.addEventListener('click', (e) => {
      if (!e.target.classList.contains('button')) flashHighlight(id, 1500);
    });
  });

  storesContainer.querySelectorAll('.openQuoteMap').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof openQuoteModal !== 'undefined') openQuoteModal(this);
    });
  });

  // Directions por data-attribute en las dos tarjetas (no se interpola la URL
  // en un onclick) y evento GA4 en los enlaces a The Fix.
  storesContainer.querySelectorAll('[data-directions]').forEach(button => {
    button.addEventListener('click', () => window.open(button.dataset.directions, '_blank'));
  });
  storesContainer.querySelectorAll('[data-partner-link]').forEach(link => {
    link.addEventListener('click', () => {
      const card = link.closest('.store-item--partner');
      trackPartnerClick(storesArray[Number(card?.dataset.index)], link.dataset.partnerLink);
    });
  });
}

// Own-store card. Every interpolated value goes through escapeHtml, like the
// partner card; the quote modal reads the data-store-* attributes.
function ownCardHTML(store, index) {
  const title = escapeHtml(store.title);
  const phone = escapeHtml(store.phone);
  return `
    <article class="store-item" tabindex="-1" data-index="${index}" data-store-id="${escapeHtml(store.id)}">
      <header class="store-name">
        <span class="store-name__title">
          <a href="/pages/${encodeURIComponent(store.handle)}" target="_blank" rel="noopener noreferrer" title="Go to ${title} page" aria-label="Go to ${title} page (opens in new tab)">
            ${title} ${LANDING_ICON}
          </a>
        </span>
        ${cardLogoHTML(CARD_LOGOS.own)}
      </header>
      <div class="store-address">${escapeHtml(store.address)}</div>
      <div class="store-address store-phone">
        <a href="tel:${phone}">${phone}</a>
      </div>
      <div class="store-btns">
        <button class="button medium" data-directions="${escapeHtml(store.gmapUrl)}">Directions</button>
        <button data-store-title="${title}" data-store-zipcode="${escapeHtml(store.zipCode)}" data-store-email="${escapeHtml(store.email)}" class="button accent medium openQuoteMap" aria-label="Get a quote from ${title}">Get a Quote</button>
        <a href="tel:${phone}" class="icon-button call-button" aria-label="Call ${title} at ${phone}" title="Call to this store">${CALL_ICON}</a>
      </div>
    </article>
  `;
}

// ===== HIGHLIGHT =====
// Keyed by store.id: cards carry data-store-id, markers live in markerById.

const LIST_SCROLL_DELAY = 150;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let listScrollTimer = null;
// Un solo temporizador para el resaltado táctil: cada toque cancela el
// anterior, si no se acumulan y apagan la tarjeta equivocada a destiempo.
let highlightTimer = null;

function cardFor(id) {
  return id ? document.querySelector(`#found-stores .store-item[data-store-id="${CSS.escape(id)}"]`) : null;
}

function highlightOnly(id) {
  clearTimeout(highlightTimer);
  removeAllHighlights();
  highlightStoreAndMarker(id);
}

function flashHighlight(id, ms) {
  highlightOnly(id);
  highlightTimer = setTimeout(() => removeHighlightStoreAndMarker(id), ms);
}

// Centra la tarjeta dentro de #found-stores si no se ve entera. Solo mueve la
// lista: scrollIntoView() arrastraría también la página.
function scrollCardIntoList(id) {
  const list = document.getElementById('found-stores');
  const card = cardFor(id);
  if (!list || !card) return;

  const listRect = list.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();
  if (cardRect.top >= listRect.top && cardRect.bottom <= listRect.bottom) return;

  const top = list.scrollTop + (cardRect.top - listRect.top) - (list.clientHeight - cardRect.height) / 2;
  list.scrollTo({ top, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
}

function setPinHover(id, on) {
  const entry = markerById.get(id);
  if (!entry) return;
  const partner = entry.store.isPartner;
  const colors = on
    ? (partner ? PARTNER_PIN_HOVER : OWN_PIN_HOVER)
    : (partner ? PARTNER_PIN : OWN_PIN);
  entry.pin.background = colors.background;
  entry.pin.borderColor = colors.borderColor;
}

function highlightStoreAndMarker(id) {
  cardFor(id)?.classList.add('highlighted');
  markerById.get(id)?.marker.element?.classList.add('marker-highlighted');
  setPinHover(id, true);
  highlightedId = id;
}

function removeHighlightStoreAndMarker(id) {
  cardFor(id)?.classList.remove('highlighted');
  markerById.get(id)?.marker.element?.classList.remove('marker-highlighted');
  setPinHover(id, false);
  if (highlightedId === id) highlightedId = null;
}

function removeAllHighlights() {
  document.querySelectorAll('#found-stores .store-item.highlighted').forEach(item => item.classList.remove('highlighted'));
  if (highlightedId) removeHighlightStoreAndMarker(highlightedId);
}

// ===== MAPA =====

window.initMap = async () => {
  try {
    const { Map } = await google.maps.importLibrary("maps");
    map = new Map(document.getElementById("map"), {
      center,
      zoom: 4,
      mapId: "FIND_STORE",
      zoomControl: true,
      cameraControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true
    });
    resolveMapReady(map);
  } catch (error) {
    console.error('❌ Error al inicializar el mapa:', error);
  }
};

// ===== URL PARAM =====

function getZipcodeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const zipcode = urlParams.get('zipcode');
  return (zipcode && /^\d{5}$/.test(zipcode)) ? zipcode : null;
}

// ===== META PIXEL: TRACKEO DE BOTONES DE LLAMADA =====
// Delegación en `document` para capturar CUALQUIER enlace tel:, sin importar
// el número. Las tarjetas de tienda se inyectan dinámicamente con innerHTML y
// cada una tiene un href distinto (tel:${store.phone}); sin esto, Meta agrupa
// el clic por URL y crea un evento por cada número. Con un solo evento 'Call'
// fijo, todos los botones de llamada se trackean como el mismo evento.
document.addEventListener('click', function (e) {
  const target = e.target.closest('a');
  if (target && target.href && target.href.includes('tel:')) {
    if (typeof fbq === 'function') fbq('trackCustom', 'Call');
  }
});

// ===== INICIALIZACIÓN PRINCIPAL =====

document.addEventListener('DOMContentLoaded', async () => {
  // Propias y aliadas en paralelo: en la primera visita las dos van a la API.
  // Punto único de merge, después de los dos caminos (caché y fallback).
  const [, partners] = await Promise.all([initStoresData(), loadPartnerStores()]);
  ALLSTORES = normalizeStores(ALLSTORES.concat(partners));
  CONFIG = readConfig();
  view.radius = CONFIG.defaultRadius;
  buildFilterOptions();
  buildCityCenters();
  initControls();
  initLocateButton();

  // The deep link (homepage ZIP entry) fills the list right away; the map
  // follows when it loads.
  const urlZipcode = getZipcodeFromURL();
  if (!urlZipcode || !searchZip(urlZipcode)) applyState();

  // Markers need both the map and the normalized stores. If the Maps API
  // never loads, the ZIP search still works as a list.
  mapReady
    .then(buildMarkers)
    .then(renderMap)
    .catch(error => console.error('❌ Error al crear los marcadores:', error));
});
